import { useState } from "react";
import styles from "./CheckBox.module.scss";

interface CustomCheckboxProps {
  icon: string;
  text: string | undefined;
  containerClassName?: string;
  color?: string;
  onChange?: (checked: boolean) => void;
  error?: string;
  checked?: boolean;
  disabled?: boolean;
  disabledColor?: string; // Yeni prop
}

const CustomCheckbox = ({
  icon,
  text,
  containerClassName = "",
  color = "",
  error,
  onChange,
  checked,
  disabled,
  disabledColor = "red",
}: CustomCheckboxProps) => {
  const [isCheck, setIsCheck] = useState(false);

  const handleToggle = () => {
    if (disabled) return;
    const newValue = !isCheck;
    setIsCheck(newValue);
    onChange?.(newValue);
  };

  return (
    <div
      className={`${styles.checkBoxContainer} ${containerClassName} ${
        disabled ? styles.disabled : ""
      }`}
    >
      <div className={styles.checkBox}>
        <span
          style={{
            borderColor: disabled ? disabledColor : color, // Disabled olduqda rəng dəyişir
          }}
          className={styles.checkBoxImg}
          onClick={handleToggle}
        >
          {checked && <img src={icon} alt="CheckBox" />}
        </span>
      </div>
      <p
        onClick={handleToggle}
        className={styles.checkBoxText}
        style={{
          color: disabled ? disabledColor : color, // Disabled olduqda rəng dəyişir
        }}
      >
        {text}
      </p>
      <p className={styles.error_message}>{error}</p>
    </div>
  );
};

export default CustomCheckbox;
